import axios from "axios";
import React, { createContext, useReducer, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "../components/LoadingScreen/LoadingScreen";
import { ENDPOINT, getJWT, getOutletSessionId } from "../helpers/Helper";
import { cartReducer } from "../reducers/cartReducer";

export const CartContext = createContext();

function CartContextProvider(props) {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState();
  const [cartId, setCartId] = useState();
  const [reload, setReload] = useState(false);

  useEffect(() => {
    setLoading(true);
    const jwt = getJWT();
    const sessionId = getOutletSessionId();

    if (jwt === undefined || null) {
      axios
        .get(`${ENDPOINT}/cart`, { headers: { sessionId: sessionId } })
        .then((res) => {
          setCartId(res && res.data.data._id);
          setProducts(res && res.data.data.products);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err.response.data.error);
          // alert(err)
          setLoading(false);
        });
    } else {
      axios
        .get(`${ENDPOINT}/cart`, {
          headers: { Authorization: `Bearer ${jwt}`, sessionId: sessionId },
        })
        .then((res) => {
          setCartId(res && res.data.data._id);
          setProducts(res && res.data.data.products);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err.response.data.error);
          setProducts();
          setLoading(false);
        });
    }
  }, [reload, getJWT()]);

  const addProductToCart = (productId, quantity) => {
    axios
      .post(
        `${ENDPOINT}/cart`,
        {
          productId: productId,
          quantity: quantity + 1,
        },
        { headers: { Authorization: `Bearer ${getJWT()}` } }
      )
      .then((res) => {})
      .catch((err) => {
        console.log(err.response.data.error);
      });
  };

  const triggerReload = () => {
    setReload(!reload);
  };

  return (
    <CartContext.Provider
      value={{ products, addProductToCart, triggerReload, cartId }}
    >
      {props.children}
    </CartContext.Provider>
  );
}

export default CartContextProvider;
